import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
// import 'rxjs/Rx';
import { AuthService } from '../auth-service/authService';
import 'rxjs-compat/add/observable/of';
import 'rxjs-compat/add/operator/map';
import { catchError, map } from 'rxjs/operators';
import { EmailUtilService } from '../services/email-util.service';
import { apiConfig } from "../config/main-config";
import * as CryptoJS from 'crypto-js';
// declare var require: any;
const Buffer = require('buffer/').Buffer;
const DEFAULT_AGE = 10000;
const pako = require('pako');

// tslint:disable:triple-equals
export class CacheEntry {
  url: string;
  request: string;
  response: HttpResponse<any>;
  exitTime: number;
}


@Injectable()
export class HttpService {

  constructor(private _http: HttpClient, private _userService: AuthService, private _router: Router,
    // private enumDataService: EnumDataService
  ) {
    this.authToken = this._userService.getToken();
  }

  errorObservable = catchError(err => {
    if (err.error) {
      if (err.error.message) {
        return throwError(err.error.message);
      } else {
        return throwError('Something went wrong !');
      }
    } else {
      return throwError(err);
    }
  });

  authToken: any = '';
  private baseUrl = '';
  private timeStamp = new BehaviorSubject('');
  private enumDataProd = apiConfig.PRODUCTION;
  cacheMap = new Map<string, CacheEntry>();

  percentDone: any;
  callEvent: any = 'events';

  /**
   * @description - This method will send back payload/response or throw error as per the status received
   * @param res - the response object received from the api calls
   */
  sendSuccessResponse(res) {
    if (res.status === 200 || res.status === 201) {
      if (res.payLoad) {
        const resData = this.changeBase64ToString(res);
        return resData;
      } else {
        return res.message;
      }
    } else if (res.status == 'active') {
      return res;
    } else if (res.status === 304 || 204) {
      throw new Error(res.message);
    } else {
      throw new Error(res.message);
    }
  }

  post(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      let headers = new HttpHeaders().set('Content-Type', 'application/json');
      if (apiConfig.PRODUCTION) {
        headers = headers.set('Content-Encoding', 'gzip');
      }
      headers = headers.set('Content-Type', 'application/json');
      httpOptions = {
        headers
      };
      if (url.includes('v2') && this._userService.getJwtToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken());
      }
      if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
      }
    }

    let compressedBody;
    if (body instanceof String) {
      compressedBody = pako.gzip(body);
    } else {
      compressedBody = pako.gzip(JSON.stringify(body));
    }
    console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));

    // console.log('compressedBody : ', pako.gzip(JSON.stringify(body)));
    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        return this.sendSuccessResponse(res);
      });
  }
  postWithRequestBase64(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      let headers = new HttpHeaders().set('Content-Type', 'application/json');
      if (apiConfig.PRODUCTION) {
        headers = headers.set('Content-Encoding', 'gzip');
      }
      headers = headers.set('Content-Type', 'application/json');
      httpOptions = {
        headers
      };
      if (url.includes('v2') && this._userService.getJwtToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken());
      }
      if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
      }
    }

    const inputData = { query: this.changeBase64Data(body) };
    let compressedBody = pako.gzip(JSON.stringify(inputData));

    console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));

    // console.log('compressedBody : ', pako.gzip(JSON.stringify(body)));
    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        return this.sendSuccessResponse(res);
      });
  }

  postDecryptWithMasterKey(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      // let headers = new HttpHeaders().set('Content-Type', 'application/json');
      let headers: HttpHeaders = new HttpHeaders();
      if (apiConfig.PRODUCTION) {
        headers = headers.set('Content-Encoding', 'gzip');
      }
      headers = headers.set('Content-Type', 'application/json');
      httpOptions = {
        headers
      };
      if (url.includes('v2') && this._userService.getJwtToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken())
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      }
      else if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      }
      else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
        httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      } else {
        httpOptions.headers = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      }
    }

    let compressedBody;
    if (body instanceof String) {
      compressedBody = pako.gzip(body);
    } else {
      compressedBody = pako.gzip(JSON.stringify(body));
    }
    if (!this.enumDataProd) {
      console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));
    }

    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 200 || res.status === 201) {
          if (res.payLoad) {
            //const resData = this.changeBase64ToString(res);
            const resData = (url.includes('v2')) ? this.decryptResponseWithMasterKey(res) : this.changeBase64ToString(res);
            return resData;
          } else {
            return res.message;
          }
        } else if (res.status == 'active') {
          return res;
        } else if (res.status === 304 || 204) {
          throw new Error(res.message);
        } else {
          throw new Error(res.message);
        }
      });
  }

  decryptResponseWithMasterKey(res) {
    const encodedata = res.payLoad;
    this.setCurrentTimestamp(res.timestamp)
    try {
      var secretKey = CryptoJS.enc.Utf8.parse(this._userService.masterKey);
      var encryptedData = CryptoJS.enc.Base64.parse(encodedata);
      // Decrypt
      var decryptedBytes = CryptoJS.AES.decrypt({ ciphertext: encryptedData }, secretKey, { mode: CryptoJS.mode.ECB });
      var decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    } catch (e) {
      console.log('in catch ', e);

    }
  }

  postEncodedDecryptWithMasterKey(url: string, body,): Observable<any> {
    let httpOptions: { headers: HttpHeaders };
    let headers: HttpHeaders = new HttpHeaders();
    if (apiConfig.PRODUCTION || url == "https://apis.ifanow.com/userserver/api/v1/web/user/generate/login/otp")
      headers = headers.set('Content-Encoding', 'gzip');
    headers = headers.set('Content-Type', 'application/json');
    httpOptions = {
      headers
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0');
    } else if (this._userService.getTokenSignUp()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    } else {
      httpOptions.headers = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    }


    const inputData = { query: this.changeBase64Data(body) };
    if (!this.enumDataProd) {
      console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body), ' requestBodyEncode : ', inputData);
    }

    const compressedBody = pako.gzip(JSON.stringify(inputData));
    //httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401 || res.status === 403) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200 || res.status === 201) {
          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponseWithMasterKey(res);
          const resData = (url.includes('v2')) ? this.decryptResponseWithMasterKey(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }
  /** Build all headers in one place. */
  private buildHeaders(url: string): HttpHeaders {




    let headers = new HttpHeaders().set('Content-Type', 'application/json');

    if (apiConfig.PRODUCTION) {
      headers = headers.set('Content-Encoding', 'gzip');
    }
    const versionMatch = url.match(/\/api\/(v\d+)\//);
    const apiVersion = versionMatch ? versionMatch[1] : 'v1'; // default to v1 if not found
    headers = headers.set('X-API-Version', apiVersion);
    const sessionId = localStorage.getItem('sessionLoginId')?.toString() ?? '0';

    if ((url.includes('v2') || url.includes('v3')) && this._userService.getJwtToken()) {
      headers = headers
        .set('Authorization', this._userService.getJwtToken())
        .set('X-Session-Id', sessionId);
    } else if (this._userService.getToken()) {
      headers = headers
        .set('Authorization', this._userService.getToken())
        .set('Content-Encoding', 'gzip');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() !== 'Basic null') {
      headers = new HttpHeaders()
        .set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json')
        .set('Content-Encoding', 'gzip');
    } else {
      headers = headers.set('sessionId', sessionId);
    }

    const tokenId = localStorage.getItem('tokenID');
    if (tokenId && tokenId !== 'undefined') {
      headers = headers.set('X-Token-Id', tokenId);
    }

    return headers;
  }
  private compressBody(body: any): Uint8Array {
    const text = body instanceof String ? body : JSON.stringify(body);
    return pako.gzip(text);
  }
  postEncodedWithRequestEncryption(url: string, body: any): Observable<any> {
    // V3 path
    const httpOptions = { headers: this.buildHeaders(url) };

    // // special V2 endpoints that expect a RAW encrypted string (no {query: ...})
    // const specialV2Paths = new Set<string>([
    //   'mutual-fund/familymember/total/sip/count/post',
    //   'mutual-fund/familymember-wise/sip/list/post',
    //   'mutual-fund/mutualFundTransaction/filtered/list/get',
    // ]);
    // const relativePath = this.relativePathAfterWeb(url);
    // const isV2 = url.includes('v2');
    // const isSpecialV2 = isV2 && specialV2Paths.has(relativePath);

    // Build request payload
    let inputData: any;
    // if (isSpecialV2) {
    //   // raw encrypted string for those endpoints
    //   const rawEncrypted = this._userService.encryptWithMasterKey(body);
    //   inputData = apiConfig.PRODUCTION ? this.compressBody(rawEncrypted).buffer : rawEncrypted;
    // } else if (isV2) {
    //   // default v2: { query: encryptedWithMasterKey(...) }
    //   const encrypted = this._userService.encryptWithMasterKey(body);
    //   const wrapped = { query: encrypted };
    //   inputData = apiConfig.PRODUCTION ? this.compressBody(wrapped).buffer : wrapped;
    // } else {
    // v1 fallback: { query: base64(...) }
    const wrapped = { query: this.changeBase64Data(body) };
    inputData = apiConfig.PRODUCTION ? this.compressBody(wrapped).buffer : wrapped;
    // }

    return this._http
      .post(this.baseUrl + url, inputData, httpOptions)
      .pipe(
        this.errorObservable,
        map((res: any) => {
          // preserve your original explicit KYC branch

          // normal path (for v2 you wanted regular decrypt, not master)
          return this.handleResponse(url, res);
        })
      );
  }

  private handleResponse(
    url: string,
    res: any,
    decryptKey?: 'master' | 'secret' // 'secret' = normal decrypt
  ): any {
    // Success
    if (res?.status === 200 || res?.status === 201) {
      if (res?.payLoad) {
        const isV2 = url.includes('v2');

        if (isV2 && decryptKey === 'master') {
          return this.decryptResponseWithMasterKey(res);
        }

        if (isV2) {
          return this.decryptResponse(res);
        }

        // v1 default
        return this.changeBase64ToString(res);
      }

      // Some endpoints return only a message
      return res?.message ?? res;
    }

    // Special non-error state
    if (res?.status === 'active') return res;

    // No content / not modified treated as errors in your original code
    if (res?.status === 304 || res?.status === 204) {
      throw new Error(res?.message);
    }

    // Fallback error
    throw new Error(res?.message);
  }
  postEncoded(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      let headers: HttpHeaders = new HttpHeaders();
      if (apiConfig.PRODUCTION)
        headers = headers.set('Content-Encoding', 'gzip');
      headers = headers.set('Content-Type', 'application/json');
      httpOptions = {
        headers
      };
      if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
      }
    }
    // console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));
    const inputData = { query: this.changeBase64Data(body) };
    const compressedBody = pako.gzip(JSON.stringify(inputData));

    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {

        if (res.status === 200 || res.status === 201) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  postEncoded1(url: string, body: any): Observable<any> {
    let httpOptions: { headers: HttpHeaders };
    let headers: HttpHeaders = new HttpHeaders();
    if (apiConfig.PRODUCTION || url == "https://apis.ifanow.com/userserver/api/v1/web/user/generate/login/otp")
      headers = headers.set('Content-Encoding', 'gzip');
    headers = headers.set('Content-Type', 'application/json');
    httpOptions = {
      headers
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
    } else if (this._userService.getTokenSignUp()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    }
    if (!this.enumDataProd) {
      console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));
    }
    const inputData = this.changeBase64Data(body);
    const compressedBody = pako.gzip(JSON.stringify(inputData));
    //httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        body = {};
        if (res.status === 401) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200 || res.status === 201) {
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });

  }


  postEncodedLogin(url: string, body,): Observable<any> {
    let httpOptions: { headers: HttpHeaders };
    let headers: HttpHeaders = new HttpHeaders();
    if (apiConfig.PRODUCTION || url == "https://pinnacle.ifanow.in/userserver/api/v1/web/user/generate/login/otp")
      headers = headers.set('Content-Encoding', 'gzip');
    headers = headers.set('Content-Type', 'application/json');
    httpOptions = {
      headers
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0');
    } else if (this._userService.getTokenSignUp()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    } else {
      httpOptions.headers = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
    }


    const inputData = { query: this.changeBase64Data(body) };
    if (!this.enumDataProd) {
      console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body), ' requestBodyEncode : ', inputData);
    }

    const compressedBody = pako.gzip(JSON.stringify(inputData));
    //httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
    return this._http
      .post(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401 || res.status === 403) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200 || res.status === 201) {
          //const resData = this.changeBase64ToString(res);
          // const resData = this.decryptResponseWithMasterKey(res);
          const resData = (url.includes('v2')) ? this.decryptResponseWithMasterKey(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }



  postEncodedWithouAuth(url: string, body: any): Observable<any> {
    let httpOptions: { headers: HttpHeaders };
    let headers: HttpHeaders = new HttpHeaders();
    if (apiConfig.PRODUCTION || url == "https://apis.ifanow.com/userserver/api/v1/web/user/generate/login/otp")
      headers = headers.set('Content-Encoding', 'gzip');
    headers = headers.set('Content-Type', 'application/json');
    httpOptions = {
      headers
    };
    httpOptions.headers = new HttpHeaders().set('Content-Type', 'application/json');
    // const inputData = this.changeBase64Data(body);
    // const compressedBody = pako.gzip(JSON.stringify(inputData));
    //httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
    return this._http
      .post(url, body, httpOptions)
      .map((res: any) => {
        body = {};
        if (res.status === 401) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200 || res.status === 201) {
          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });

  }


  putEncoded(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      let headers: HttpHeaders = new HttpHeaders();
      if (apiConfig.PRODUCTION)
        headers = headers.set('Content-Encoding', 'gzip');
      headers = headers.set('Content-Type', 'application/json');

      // headers = headers.set('Content-Type', 'application/octet-stream');
      httpOptions = {
        headers
      };
      // httpOptions = {
      //   headers: new HttpHeaders().set('Content-Type', 'application/json')
      // };

      if (url.includes('v2') && this._userService.getJwtToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken())
      } else if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
      }
    }

    const inputData = { query: this.changeBase64Data(body) };
    const compressedBody = pako.gzip(JSON.stringify(inputData));
    console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));

    return this._http
      .put(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {

        if (res.status === 200 || res.status === 201) {

          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  putEncodedDecryptWithMasterKey(url: string, body, options?): Observable<any> {
    let httpOptions: { headers: HttpHeaders };

    if (options) {
      httpOptions = options;
    } else {
      let headers: HttpHeaders = new HttpHeaders();
      if (apiConfig.PRODUCTION)
        headers = headers.set('Content-Encoding', 'gzip');
      headers = headers.set('Content-Type', 'application/json');

      // headers = headers.set('Content-Type', 'application/octet-stream');
      httpOptions = {
        headers
      };
      // httpOptions = {
      //   headers: new HttpHeaders().set('Content-Type', 'application/json')
      // };

      if (url.includes('v2') && this._userService.getJwtToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getJwtToken())
          .set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0').set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      }
      else if (this._userService.getToken()) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0').set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
        httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      } else {
        httpOptions.headers = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
          .set('Content-Type', 'application/json').set('Content-Encoding', 'gzip');
      }
    }

    const inputData = { query: this.changeBase64Data(body) };
    const compressedBody = pako.gzip(JSON.stringify(inputData));
    if (!this.enumDataProd) {
      console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));
    }

    return this._http
      .put(this.baseUrl + url, apiConfig.PRODUCTION ? compressedBody.buffer : inputData, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401 || res.status === 403) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200 || res.status === 201) {

          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponseWithMasterKey(res);
          const resData = (url.includes('v2')) ? this.decryptResponseWithMasterKey(res) : this.changeBase64ToString(res);
          return resData;
        } else {

          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }


  put(url: string, body, params?): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    // if (apiConfig.PRODUCTION)
    //   headers = headers.set('Content-Encoding', 'gzip');
    headers = headers.set('Content-Type', 'application/json');

    let httpOptions: any = {
      headers,
      params: undefined
    };
    if (this._userService.getToken()) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this._userService.getToken());
    }
    if (params != undefined) {
      httpOptions = params;
    }

    // const compressedBody = pako.gzip(JSON.stringify(body));
    console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));

    return this._http
      .put(this.baseUrl + url, body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res == null) {
          return res;
        } else if (res.status === 200) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else if (res.status === 304 || 204) {
          throw new Error(res.message);
        } else {
          const err = new Error(res.message);
          throwError(err);
          // this._router.navigate(['login']);
        }
      });
  }

  putParam(url: string, body, params?): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json'), params
    };
    // if (params != undefined) {
    //   httpOptions = params;
    // }

    return this._http
      .put(this.baseUrl + url, body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res == null) {
          return res;
        } else if (res.status === 200) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          const err = new Error(res.message);
          throwError(err);
          // this._router.navigate(['login']);
        }
      });
  }

  putWithStatusCode(url: string, body, options?) {
    let httpOptions = {
      headers: new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json')
    };
    if (options != undefined) {
      httpOptions = options;
    }

    return this._http
      .put(this.baseUrl + url, body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res == null) {
          return res;
        } else if (res.status === 200) {
          const resData = this.changeBase64ToString(res);
          return { res: resData, statusCode: res.status };
        } else {
          const err = new Error(res.message);
          throwError(err);
          // this._router.navigate(['login']);
        }
      });
  }

  putExternal(url: string, body, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Authorization', this._userService.getToken()).set('Content-Type', 'application/json'),
      reportProgress: true,
      observe: this.callEvent
    };
    if (options != undefined) {
      httpOptions = options;
    }
    console.log(HttpEventType.UploadProgress, 'HttpEventType.UploadProgress');

    return this._http
      .put<any>(this.baseUrl + url, body, httpOptions).pipe(this.errorObservable);
  }

  delete(url: string, body, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json'),
      body
    };
    if (options != undefined) {
      httpOptions = options;
    }

    return this._http
      .request('delete', url, { body }).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 200) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          const err = new Error(res.message);
          throwError(err);

          // this._router.navigate(['login']);
        }
      });
  }

  deleteParams(url: string, params, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json'),
      params
    };
    if (options != undefined) {
      httpOptions = options;
    }
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    }
    return this._http
      .delete(url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200) {
          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else {
          const err = new Error(res.message);
          throwError(err);

          // this._router.navigate(['login']);
        }
      });
  }


  deleteExpiredCache() {
    this.cacheMap.forEach(entry => {
      if (entry.exitTime < Date.now()) {
        this.cacheMap.delete(entry.url);
      }
    });
  }


  getEncoded(url: string, params, requestAge?: number): Observable<any> {
    if (!requestAge) {
      requestAge = DEFAULT_AGE;
    }
    const objJson64 = this.changeBase64Data(params);
    const entry = this.cacheMap.get(url);
    if (entry) {
      const isExpired = entry.exitTime < Date.now();
      if (isExpired) {
        this.deleteExpiredCache();
      } else if (entry.request === objJson64) {
        return Observable.of((entry.response));
      }
    }
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', objJson64);
    let httpHeader: HttpHeaders;
    if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this._http
      .get(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if ([200, 201, 202, 204].includes(res.status)) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getEncodedBasic(url: string, params, requestAge: number): Observable<any> {
    if (!requestAge) {
      requestAge = DEFAULT_AGE;
    }
    const objJson64 = this.changeBase64Data(params);
    const entry = this.cacheMap.get(url);
    if (entry) {
      const isExpired = entry.exitTime < Date.now();
      if (isExpired) {
        this.deleteExpiredCache();
      } else if (entry.request === objJson64) {
        return Observable.of((entry.response));
      }
    }
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', objJson64);
    let httpHeader: HttpHeaders;
    if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this._http
      .get(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if ([200].includes(res.status)) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          // this._router.navigate(['login']);
          // throw new Error(res.message);
        }
      });
  }

  getWithoutAuth(url: string, params, requestAge: number = undefined): Observable<any> {
    if (!requestAge) {
      requestAge = DEFAULT_AGE;
    }
    // const objJson64 = this.changeBase64Data(params);
    const entry = this.cacheMap.get(url);
    if (entry) {
      const isExpired = entry.exitTime < Date.now();
      if (isExpired) {
        this.deleteExpiredCache();
      } else if (entry.request === params) {
        return Observable.of((entry.response));
      }
    }
    const httpParams = params;
    // httpParams = httpParams.append('query', params);
    let httpHeader: HttpHeaders;
    if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this._http
      .get(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if ([200].includes(res.status)) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          // this._router.navigate(['login']);
          // throw new Error(res.message);
        }
      });
  }


  getEncodedNew(url: string, params, requestAge?: number): Observable<any> {
    if (!requestAge) {
      requestAge = DEFAULT_AGE;
    }
    const objJson64 = this.changeBase64Data(params);
    const entry = this.cacheMap.get(url);
    if (entry) {
      const isExpired = entry.exitTime < Date.now();
      if (isExpired) {
        this.deleteExpiredCache();
      } else if (entry.request === objJson64) {
        return Observable.of((entry.response));
      }
    }
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', objJson64);
    let httpHeader: HttpHeaders;
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this._http
      .get(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if ([200, 201, 202, 204].includes(res.status)) {
          /// const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponseWithMasterKey(res);
          const resData = (url.includes('v2')) ? this.decryptResponseWithMasterKey(res) : this.changeBase64ToString(res);
          return resData;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  // getMethod(url: string, params): Observable<any> {
  //   let httpParams = new HttpParams();
  //   const httpOptions = {
  //     headers: new HttpHeaders().set('authToken', this._userService.getToken())
  //       .set('Content-Type', 'application/json'),
  //        params: params
  //   };
  //   url = url.trim();
  //   return this._http
  //     .get(this.baseUrl + url, httpOptions)
  //     .map((res: any) => {
  //       if (res['status'] === 'AUTH_TOKEN_EXPIRED') {
  //         window.alert('Invalid user, please login');
  //         this._router.navigate(['login']);
  //       }
  //     });
  // }


  // ------------------------Aman jain code date 22 aug ------------------------------------------------------

  get(url: string, params): Observable<any> {
    const httpParams = params;
    // httpParams = httpParams.append('query', params);
    let httpHeader: HttpHeaders;
    if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this.getHttpClient(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 200 || res.status === 204) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else if (res.message === "No Data Found" && res.status === 500) {
          return null;
        }
        else if (res.status === 204 || res.status === 400) {
          return null;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getWithoutDecryption(url: string, params): Observable<any> {
    const httpParams = params;
    // httpParams = httpParams.append('query', params);
    let httpHeader: HttpHeaders;
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp()).set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('sessionId', localStorage.getItem('sessionLoginId')?.toString() ?? '0')
        .set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this.getHttpClient(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401 || res.status === 403) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200) {
          // const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else if (res.status === 204) {
          return null;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getEncodedAuth(url: string, params, requestAge?: number): Observable<any> {
    if (!requestAge) {
      requestAge = DEFAULT_AGE;
    }
    const objJson64 = this.changeBase64Data(params);
    const entry = this.cacheMap.get(url);
    if (entry) {
      const isExpired = entry.exitTime < Date.now();
      if (isExpired) {
        this.deleteExpiredCache();
      } else if (entry.request === objJson64) {
        return Observable.of((entry.response));
      }
    }
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', objJson64);
    let httpHeader: HttpHeaders;
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this._http
      .get(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401) {
          this._router.navigate(['/login']);
        }
        if ([200, 201, 202, 204].includes(res.status)) {
          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getAuth(url: string, params): Observable<any> {
    const httpParams = params;
    // httpParams = httpParams.append('query', params);
    let httpHeader: HttpHeaders;
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this.getHttpClient(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res.status === 401) {
          this._router.navigate(['/login']);
        }
        if (res.status === 200) {
          //const resData = this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
          return resData;
        } else if (res.status === 204) {
          return null;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  // getPdf(url: string, params): Observable<any> {
  //   const httpParams = params;
  //   // httpParams = httpParams.append('query', params);
  //   let httpHeader: HttpHeaders;

  //   httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
  //   const httpOptions = {
  //     headers: httpHeader,
  //     params: httpParams
  //   };
  //   url = url.trim();
  //   return this.getHttpClient(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
  //     .map((res: any) => {
  //       console.log(res);

  //       if (res.status === 200) {
  //         const resData = this.changeBase64ToString(res);
  //         return resData;
  //       } else if (res.status === 204) {
  //         return null;
  //       } else {
  //         // this._router.navigate(['login']);
  //         throw new Error(res.message);
  //       }
  //     });
  // }

  getMessage(url: string, params): Observable<any> {
    const httpParams = params;
    // httpParams = httpParams.append('query', params);
    let httpHeader: HttpHeaders;
    if (this._userService.getToken()) {
      httpHeader = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else {
      httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    }
    const httpOptions = {
      headers: httpHeader,
      params: httpParams
    };
    url = url.trim();
    return this.getHttpClient(this.baseUrl + url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {

        if (res.status === 200) {
          const resData = this.changeBase64ToStringMes(res);
          return resData;
        } else if (res.status === 204) {
          return res;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getHttpClient(url, httpOptions?) {
    return this._http
      .get(url, httpOptions);
  }

  // created by sarvesh

  changeBase64Data(params): string {
    const objJsonStr = JSON.stringify(params);
    const objJsonB64 = Buffer.from(objJsonStr).toString('base64');
    return objJsonB64;
  }

  changeBase64ToString(res) {
    const encodedata = res.payLoad;
    try {
      const datavalue = (Buffer.from(encodedata, 'base64').toString('utf-8'));

      try {
        const responseData = JSON.parse(datavalue);
        return responseData;
      } catch (e) {
        return JSON.parse(EmailUtilService.parseBase64AndDecodeGoogleUrlEncoding(encodedata));
      }
    } catch (e) {
      console.error(e);
      return encodedata;
    }
  }

  changeBase64ToStringMes(res) {
    const response = {
      message: res.message,
      payload: res.payLoad
    }
    try {
      const datavalue = (Buffer.from(res.payLoad, 'base64').toString('utf-8'));

      try {
        const responseData = JSON.parse(datavalue);
        const response = {
          message: res.message,
          payload: JSON.parse(datavalue)
        }
        return response;
      } catch (e) {
        return JSON.parse(EmailUtilService.parseBase64AndDecodeGoogleUrlEncoding(response));
      }
    } catch (e) {
      console.log(e);

      return response;
    }
  }

  // ----------------------- End  getmethod url  Code ------------------------------------------------------

  postExternal(url: string, body, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };
    let headers: HttpHeaders;
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    }
    else {
      httpOptions.headers = new HttpHeaders().set('Content-Type', 'application/json');
    }
    if (options != undefined) {
      httpOptions = options;
    }
    return this._http
      .post(url, body, httpOptions)
      .pipe(
        catchError(err => of([]))

        // catchError(err => {
        //
        //   // return throwError(err);
        // })
      );
  }

  postExternal1(url: string, body, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    } else {
      httpOptions.headers = new HttpHeaders().set('Content-Type', 'application/json');
    }
    if (options != undefined) {
      httpOptions = options;
    }
    return this._http
      .post(url, body, httpOptions);
  }


  getExternal(url: string, options?): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', 'http://localhost:4200')
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    } else {
      httpOptions.headers = new HttpHeaders().set('Content-Type', 'application/json');
    }
    if (options != undefined) {
      httpOptions = options;
    }
    return this._http
      .get(url, httpOptions).pipe(
        catchError(err => of([]))

        // catchError(err => {
        //
        //   // return throwError(err);
        // })
      );
  }

  //    delete(url:string, params?){
  //      let httpOptions = {
  //        headers: new HttpHeaders().set('authToken', this._userService.getToken())
  //        .set('Content-Type', 'application/json')
  //      };
  //      if(params){
  //        httpOptions["params"] = params;
  //      }
  //      return this._http.delete( ${environment.carNationUrl} + url, httpOptions)
  //                  .map((res: ArrayBuffer) => {
  //                    if(res['status'] == 'AUTH_TOKEN_EXPIRED'){
  //                      window.alert("Invalid user, please login");
  //                      this._router.navigate(['login']);
  //                    }else{
  //                      return res;
  //                    }
  //                  })
  //                  .catch((err)=>{
  //                    return Observable.throw(err);
  //                  });
  //    }
  //    login(url:string, body, options?){
  //      let httpOptions = {
  //        headers: new HttpHeaders()
  //        .set('Content-Type', 'application/json')
  //      };
  //      if(options != undefined){
  //        httpOptions = options
  //      }
  //      return this._http
  //        .post(${environment.userLogin} , body, httpOptions)
  //        .map((res: ArrayBuffer) => res);
  //    }
  getAws(url) {
    // let httpOptions = {
    //   headers: new HttpHeaders().set('Content-Type', 'application/json')
    // }
    return this._http.get(url).pipe(this.errorObservable)
      .map((res: any) => {
        if (res) {
          return res;
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getCall(url) {
    let httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };
    if (url.includes('v2') && this._userService.getJwtToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getJwtToken())
        .set('Content-Type', 'application/json');
    }
    else if (this._userService.getToken()) {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getToken())
        .set('Content-Type', 'application/json');
    } else if (this._userService.getTokenSignUp() && this._userService.getTokenSignUp() != 'Basic null') {
      httpOptions.headers = new HttpHeaders().set('Authorization', this._userService.getTokenSignUp())
        .set('Content-Type', 'application/json');
    } else {
      httpOptions.headers = new HttpHeaders().set('Content-Type', 'application/json');
    }
    return this._http.get(url, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res) {
          //return this.changeBase64ToString(res);
          //const resData = this.decryptResponse(res);
          const resData = (url.includes('v2')) ? this.decryptResponse(res) : this.changeBase64ToString(res);
        } else {
          // this._router.navigate(['login']);
          throw new Error(res.message);
        }
      });
  }

  getBaseUrl() {
    return this.baseUrl;
  }
  putPdf(url: string, body, params?): Observable<any> {
    let httpHeader: HttpHeaders = new HttpHeaders();
    httpHeader = new HttpHeaders().set('Content-Type', 'application/json');
    const httpOptions = {
      headers: params
    };
    // const compressedBody = pako.gzip(JSON.stringify(body));
    console.log('Request api :', this.baseUrl + url, ' requestBody : ', JSON.stringify(body));

    return this._http
      .put(this.baseUrl + url, body, httpOptions).pipe(this.errorObservable)
      .map((res: any) => {
        if (res == null) {
          return res;
        } else if (res.status === 200) {
          const resData = this.changeBase64ToString(res);
          return resData;
        } else {
          const err = new Error(res.message);
          throwError(err);
          // this._router.navigate(['login']);
        }
      });
  }

  setCurrentTimestamp(time) {
    this.timeStamp.next(time);
  }

  decryptResponse(res) {
    const encodedata = res.payLoad;
    this.setCurrentTimestamp(res.timestamp)
    try {
      var secretKey = CryptoJS.enc.Utf8.parse(this._userService.getDecryptedKey());
      var encryptedData = CryptoJS.enc.Base64.parse(encodedata);
      // Decrypt
      var decryptedBytes = CryptoJS.AES.decrypt({ ciphertext: encryptedData }, secretKey, { mode: CryptoJS.mode.ECB });
      var decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    } catch (e) {
      console.log('in catch ', e);
    }

  }
}
